(function () {
  function formatMoney(cents, currency, locale) {
  const value = cents / 100;

  try {
    return new Intl.NumberFormat(locale || 'pt-BR', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value) + ' ' + (currency || 'BRL');

  } catch (e) {
    return value.toFixed(2).replace('.', ',') + ' BRL';
  }
}

  function renderWholesaleTable(section) {
    const body = section.querySelector('[data-wholesale-body]');
    const configScript = section.querySelector('[data-wholesale-config]');
    const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');

    if (!body || !configScript) return;

    let config;

    try {
      config = JSON.parse(configScript.textContent);
    } catch (e) {
      return;
    }

    let priceCents = config.defaultPriceCents;

    if (variantInput && config.variants && config.variants[variantInput.value]) {
      priceCents = config.variants[variantInput.value];
    }

    const rows = config.rows || [];

    body.innerHTML = rows.map(function (row) {
  const discountedCents = Math.round(priceCents * (1 - row.discount / 100));
  const pixDiscount = config.pixDiscount || 5;
  const pixCents = Math.round(discountedCents * (1 - pixDiscount / 100));

  return `
    <tr>
      <td>${row.quantity}</td>
      <td>${
  row.discount == 0
    ? (config.noDiscountLabel || 'Sem desconto')
    : row.discount + '%'
}</td>
      <td>${formatMoney(discountedCents, config.currency, config.locale)}</td>
      <td>${formatMoney(pixCents, config.currency, config.locale)}</td>
    </tr>
  `;
}).join('');
  }

  function initWholesaleSections() {
    document.querySelectorAll('[data-de-renda-wholesale]').forEach(function (section) {
      renderWholesaleTable(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initWholesaleSections);

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('form[action*="/cart/add"] [name="id"]') ||
      event.target.closest('form[action*="/cart/add"]')
    ) {
      setTimeout(initWholesaleSections, 100);
    }
  });

  document.addEventListener('variant:change', function () {
    setTimeout(initWholesaleSections, 100);
  });

  document.addEventListener('product:variant-change', function () {
    setTimeout(initWholesaleSections, 100);
  });

  document.addEventListener('shopify:section:load', initWholesaleSections);
})();

